import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { getApi, postApi, putApi } from '../../Services/apiService';
import moment from 'moment';

const EditEventModal = ({ setEditModal, fetchEvents, eventDetails }) => {
    console.log("eventDetails",eventDetails);
    
    const [loader, setLoader] = useState(false);
    const [categories, setCategories] = useState([]);
    const [errors, setErrors] = useState({});
    const [deleteImages, setDeleteImages] = useState([]);
    const [formData, setFormData] = useState({
        name: eventDetails.name || '',
         special_offer: eventDetails.special_offer || '',
        description: eventDetails.description || '',
         entry_booking_detail: eventDetails.entry_booking_detail || '',
        booking_url: eventDetails.booking_url || '',
        start_time: eventDetails.start_time ? moment(eventDetails.start_time).format("HH:mm") : '',
        end_time: eventDetails.end_time ? moment(eventDetails.end_time).format("HH:mm") : '',
        date: eventDetails.date ? moment(eventDetails.date).format("YYYY-MM-DD") : '', 
        type: eventDetails.type || '',
        category_id: eventDetails.category_id || '',
        price: eventDetails.price || '',
        images: eventDetails?.EventImages || []
    });

const convertTimeToMilliseconds = (time) => {
    if (!time) return null;

    const [hours, minutes] = time.split(":").map(Number); // Extract hours & minutes
    const now = new Date(); // Get current date
    now.setHours(hours, minutes, 0, 0); // Set the extracted timefimages

    return now.getTime(); // Convert to milliseconds
};
    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await getApi("/admin/category");
            if (response.status === 200) {
                setCategories(response?.data?.data);
            }
        } catch (error) {
            console.error("Failed to fetch categories:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        console.log("name " , e );
        
        if (name === 'images') {
            const fileArray = Array.from(files);
            console.log("filesArray" , fileArray);
            
            setFormData((prev) => ({
                ...prev,
                images: [...prev.images, ...fileArray]
            }));
            // setFormData({ ...formData, images: filesArray });
            if (errors.images) {
                setErrors({ ...errors, images: '' });
            }
        }
    };

    // const handleRemoveFile = (index) => {
    //     const updatedImages = [...formData.images];
    //     updatedImages.splice(index, 1);
    //     setFormData({ ...formData, images: updatedImages });
    //     const updatedPreviews = [...filePreviews.images];
    //     updatedPreviews.splice(index, 1);
    //     setFilePreviews({ images: updatedPreviews });
    // };
    const removeImage = (index) => {
        setFormData((prev) => {
            const removedImage = prev.images[index];
            if (removedImage.url) {
                setDeleteImages((prevDelete) => [...prevDelete, removedImage.id]);
            }
            return {
                ...prev,
                images: prev.images.filter((_, i) => i !== index)
            };
        });
    };

    const validateForm = () => {
        let validationErrors = {};
    
        // Name validation
        if (!formData.name.trim()) {
            validationErrors.name = "Name is required.";
        } else if (formData.name.trim().length < 2 || formData.name.trim().length > 35) {
            validationErrors.name = "Name must be between 2 and 35 characters.";
        }
    
        // Description validation
        if (!formData.description.trim()) {
            validationErrors.description = "Description is required.";
        } else if (formData.description.trim().length < 2 || formData.description.trim().length > 500) {
            validationErrors.description = "Description must be between 2 and 500 characters.";
        }
    
        // Start time validation
        if (!formData.start_time.trim()) {
            validationErrors.start_time = "Start time is required.";
        }
    
        // End time validation
        if (!formData.end_time.trim()) {
            validationErrors.end_time = "End time is required.";
        }
        if (formData.start_time.trim() && formData.end_time.trim()) {
  const startTime = moment(formData.start_time, "HH:mm");
  const endTime = moment(formData.end_time, "HH:mm");
//   if (!endTime.isAfter(startTime)) {
//     validationErrors.end_time = "End time must be greater than start time.";
//   }
}
    
        // Type validation
        if (!formData.type.trim()) {
            validationErrors.type = "Type is required.";
        }

        if (!formData.date.trim()) {
            validationErrors.date = "Date is required.";
        }
    
        if (!formData.entry_booking_detail) {
            validationErrors.entry_booking_detail = "Entry Booking Detail is required.";
        }
    
         // Type validation
         if (!formData.price.trim()) {
            validationErrors.price = "Price is required.";
        }
        // Booking URL validation (Basic URL format check)
        // if (!formData.booking_url.trim()) {
        //     validationErrors.booking_url = "Booking URL is required.";
        // } else if (!/^https?:\/\/[^\s$.?#].[^\s]*$/.test(formData.booking_url)) {
        //     validationErrors.booking_url = "Enter a valid URL.";
        // }
        // Category ID validation
        if (!formData.category_id) {
            validationErrors.category_id = "Category  is required.";
        }
    
        // Image validation
        if (formData.images.length === 0) {
            validationErrors.images = "At least one image is required.";
        }
    
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        setLoader(true);
        const expiryDateTimestamp = new Date(formData.date).getTime();

        const formattedData = {
            ...formData,
            start_time: convertTimeToMilliseconds(formData.start_time),
            end_time: convertTimeToMilliseconds(formData.end_time),
            date: expiryDateTimestamp,
        };
    
        const formDataToSend = new FormData();
        Object.keys(formattedData).forEach((key) => {
            if (key === 'images' && Array.isArray(formattedData.images)) {
                formattedData.images.forEach(file => {
                    if (file instanceof File) {
                        formDataToSend.append('images', file);
                    }else if (file.url) {
                        formDataToSend.append('existingImages', file.url); // Existing images
                    }
                });
            } else {
                formDataToSend.append(key, formattedData[key]);
            }
        
        });
    
        if (deleteImages.length > 0) {
            deleteImages.forEach((img) => {
                formDataToSend.append('delete_image', img);
            });
        }


        try {
            const response = await putApi(`/admin/edit-event/${eventDetails?.id}`, formDataToSend, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
    
            if (response.status === 200) {
                setEditModal(false);  // Close the modal
                fetchEvents();  // Refresh event list
            }
        } catch (error) {
            console.error("Error editing event:", error);
        } finally {
            setLoader(false);
        }
    };
    

    return (
        <div className='detail-page-modal'>
            <div className='modal-header'>
                <h3>Edit Event</h3>
                <button className='close-button' onClick={() => setEditModal(false)}>
                    <img src={window.getPublicUrl('/assets/images/Close_round_light.svg')} alt='close' />
                </button>
            </div>
            <div className='modal-body scrollable-modal-body'>
                <div className='input-main'>
                    <div className='row'>
                        {Object.keys(formData).map((key) => (
                               key !== "images" &&
                               key !== "type" &&
                               key !== "category_id" &&
                               key !== "special_offer" &&
                               key !== "entry_booking_detail" &&
                               key !== "description" ? (
                                <div className='col-sm-6' key={key}>
                                    <div className='custom-floating-group'>
                                        <input
                                            type={
                                                key === "start_time" || key === "end_time"
                                                  ? "time"
                                                  : key === "date" 
                                                  ? "date"
                                                  : "text"
                                              }
                                            name={key}
                                            value={formData[key]}
                                            onChange={handleChange}
                                            min={key === "date" ? moment().format("YYYY-MM-DD") : undefined} 
                                        />
                                        <label>{key.replace('_', ' ')}</label>
                                        {errors[key] && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors[key]}
            </span>
          )}
                                    </div>
                                </div>
                            ) : null
                        ))}

                        <div className='col-sm-6'>
                            <div className='custom-floating-group'>
                                <select name='category_id' value={formData.category_id} onChange={handleChange}>
                                    <option value=''>Select Category</option>
                                    {categories.map((category) => (
                                        <option key={category.id} value={category.id}>{category.name}</option>
                                    ))}
                                </select>
                                <label>Category</label>
                                {errors.category_id && <span style={{ color: "red", fontSize: "14px" }}>{errors.category_id}</span>}
                            </div>
                        </div>


                        <div className='col-sm-6'>
                            <div className='custom-floating-group'>
                                <select name='type' value={formData.type} onChange={handleChange}>
                                <option value=''>Select Venue Type</option>
                                    <option value='0'>Music</option>
                                    <option value='1'>Food And Drinks</option>
                                    <option value='2'>Themed Nights </option>
                                    <option value='3'>Nightclubs & Guest Lists</option>
                                </select>
                                <label>Type</label>
                                {errors.type && <span  style={{ color: "red", fontSize: "14px" }}>{errors.type}</span>}
                            </div>
                        </div>

                        <div className="col-sm-6">
  <div className="custom-floating-group position-relative">
    <textarea
      name="description"
      value={formData.description}
      onChange={handleChange}
      placeholder=" "
      rows="4"
      className={`custom-textarea ${formData.description ? "has-content" : ""}`}
    ></textarea>
    <label className="floating-label">Description</label>
    {errors.description && (
      <span style={{ color: "red", fontSize: "14px" }}>
        {errors.description}
      </span>
    )}
  </div>
</div>
<div className="col-sm-6">
  <div className="custom-floating-group position-relative">
    <textarea
      name="special_offer"
      value={formData.special_offer}
      onChange={handleChange}
      placeholder=" "
      rows="4"
      className={`custom-textarea ${formData.special_offer ? "has-content" : ""}`}
    ></textarea>
    <label className="floating-label">Enter special offer details</label>
    {errors.special_offer && (
      <span style={{ color: "red", fontSize: "14px" }}>
        {errors.special_offer}
      </span>
    )}
  </div>
</div>
<div className="col-sm-6">
  <div className="custom-floating-group position-relative height">
    <textarea
      name="entry_booking_detail"
      value={formData.entry_booking_detail}
      onChange={handleChange}
      placeholder=" "
      rows="4"
      className={`custom-textarea ${formData.entry_booking_detail ? "has-content" : ""}`}
    ></textarea>
    <label className="floating-label">Enter booking details</label>
    {errors.entry_booking_detail && (
      <span style={{ color: "red", fontSize: "14px" }}>
        {errors.entry_booking_detail}
      </span>
    )}
  </div>
</div>

                        <div className="col-sm-6">
                            <div className="upload-wrapper">
                                <input
                                    type="file"
                                    id="images"
                                    name="images"
                                    className="upload-input"
                                    onChange={handleFileChange}
                                    multiple
                                />
                                <label htmlFor="images" className="upload-label">
                                    <img className='upload-icon' src={window.getPublicUrl("/assets/images/upload.svg")} alt="" />
                                    Images
                                    <div className="upload-box">
                                        {errors.images && (
                                            <span style={{ color: "red", fontSize: "14px" }}>
                                                {errors.images}
                                            </span>
                                        )}
                                    </div>
                                </label>
                            </div>
                            </div>
                            <div className="col-sm-12 text-center">
                            {formData.images.map((image, index) => (
                                <div className='file-preview' key={index}>
                                    <img
                                        src={image.url || URL.createObjectURL(image)}
                                        alt={image.url ? 'Existing' : 'Selected'}
                                        width='100'
                                    />
                                    <button className='cross' onClick={() => removeImage(index)}>
                                        <img src={window.getPublicUrl('/assets/images/gray-cross.svg')} alt='close' />
                                    </button>
                                </div>
                            ))}
                            {errors.images && <span style={{ color: "red", fontSize: "14px" }}>{errors.images}</span>}
                       </div>
                    </div>
                </div>
            </div>
            <div className='modal-footer'>
                <button className='cancel' onClick={() => setEditModal(false)}>Cancel</button>
                <button className='save' onClick={handleSubmit} disabled={loader}>{loader ? 'Saving...' : 'Save'}</button>
            </div>
        </div>
    );
};

export default EditEventModal;
